import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import useOnClickOutside from "common/hooks/useOnClickOutside"
import { useTaxes } from "features/User/pages/Taxes/useTaxes"
import { AnimatePresence, motion } from "framer-motion"
import { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import "./styles.scss"

const TaxesCustomer = ({ values, setFields, isCliente }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  const { taxes, getAllTaxes } = useTaxes()
  const [showTaxes, toggleShowTaxes] = useState(false)

  const ref = useRef()
  // @ts-expect-error TS(2554): Expected 4 arguments, but got 2.
  useOnClickOutside(ref, () => toggleShowTaxes(false))

  const validateTaxeToIncluide = (taxe: $TSMigrationFixMe) => {
    setFields(`${isCliente ? "cliente" : "proveedor"}Taxes`, [
      ...values[`${isCliente ? "cliente" : "proveedor"}Taxes`],
      taxe,
    ])
    setFields(`${isCliente ? "cliente" : "proveedor"}TaxesGroups`, [
      ...values[`${isCliente ? "cliente" : "proveedor"}TaxesGroups`],
      taxe?.grupoImpuesto?.tipoGrupoImpuesto,
    ])
  }

  const handlerMessage = () => {
    const list = taxes?.map((taxe) => {
      const detailGroup = values[
        `${isCliente ? "cliente" : "proveedor"}TaxesGroups`
      ]?.some(
        (groupActive: $TSMigrationFixMe) =>
          // @ts-expect-error TS(2339): Property 'grupoImpuesto' does not exist on type 'n...
          groupActive === taxe?.grupoImpuesto?.tipoGrupoImpuesto
      )

      if (detailGroup) return null

      return taxe
    })
    return list?.filter((item) => item !== null)
  }
  const isClienteSession = isCliente ? 1 : 0

  return (
    <div className='taxe-select-customer'>
      <label className='text-left w-100'>
        {isCliente
          ? `${t("contactos.editar.dataAdvance.labelTaxSale")}`
          : `${t("contactos.editar.dataAdvance.labelTaxBuy")}`}
      </label>
      <section
        onClick={(ev) => {
          ev.preventDefault()
          toggleShowTaxes(true)
        }}
        style={{ cursor: "pointer" }}
        className='taxe-select-customer__select-container'
      >
        <div className='taxe-select-customer__items'>
          {values[`${isCliente ? "cliente" : "proveedor"}Taxes`]?.map(
            (taxeSaved: $TSMigrationFixMe) => (
              <>
                <div className='taxe-select-customer__taxe-select-input'>
                  <p>
                    {taxeSaved?.nombre}{" "}
                    <FontAwesomeIcon
                      icon={["fal", "xmark"]}
                      className='icon-plus'
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setFields(
                          `${isCliente ? "cliente" : "proveedor"}Taxes`,
                          values[
                            `${isCliente ? "cliente" : "proveedor"}Taxes`
                          ]?.filter(
                            (taxe: $TSMigrationFixMe) =>
                              taxe.grupoImpuesto.tipoGrupoImpuesto !==
                              taxeSaved.grupoImpuesto.tipoGrupoImpuesto
                          )
                        )
                        setFields(
                          `${isCliente ? "cliente" : "proveedor"}TaxesGroups`,
                          values[
                            `${isCliente ? "cliente" : "proveedor"}TaxesGroups`
                          ]?.filter(
                            (taxeActive: $TSMigrationFixMe) =>
                              taxeActive !==
                              taxeSaved.grupoImpuesto.tipoGrupoImpuesto
                          )
                        )
                      }}
                    />
                  </p>
                </div>
              </>
            )
          )}
        </div>
        <div>
          <FontAwesomeIcon
            icon={["fal", "xmark"]}
            color='red'
            onClick={() => {
              setFields(`${isCliente ? "cliente" : "proveedor"}Taxes`, [])
              setFields(`${isCliente ? "cliente" : "proveedor"}TaxesGroups`, [])
              getAllTaxes()
            }}
            className='icon-close'
          />
          <FontAwesomeIcon
            onClick={() => toggleShowTaxes(true)}
            icon={["fal", "angle-down"]}
            className='icon-plus'
          />
        </div>
      </section>

      {showTaxes && (
        <AnimatePresence>
          <motion.div
            initial='initial'
            animate='animate'
            exit='exit'
            className='taxe-select-customer__select-options'
            // @ts-expect-error TS(2322): Type 'MutableRefObject<undefined>' is not assignab...
            ref={ref}
          >
            {taxes
              ?.filter(
                // @ts-expect-error TS(2339): Property 'tipo' does not exist on type 'never'.
                (taxe) => taxe.tipo === isClienteSession && taxe.esActivo
              )
              .map((taxe) => {
                const detailGroup = values[
                  `${isCliente ? "cliente" : "proveedor"}TaxesGroups`
                ]?.some(
                  (groupActive: $TSMigrationFixMe) =>
                    // @ts-expect-error TS(2339): Property 'grupoImpuesto' does not exist on type 'n...
                    groupActive === taxe?.grupoImpuesto?.tipoGrupoImpuesto
                )
                // isCliente
                if (detailGroup) return

                return (
                  <div
                    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
                    key={taxe.id}
                    className='taxe-selected'
                    onClick={() => {
                      validateTaxeToIncluide(taxe)
                    }}
                  >
                    {/* @ts-expect-error TS(2339): Property 'nombre' does not exist on type 'never'. */}
                    {taxe.nombre} - {taxe.grupoImpuesto.categoria}
                  </div>
                )
              })}

            {handlerMessage()?.length <= 0 ? (
              <p>{t("contactos.editar.dataAdvance.advTax")}</p>
            ) : null}
          </motion.div>
        </AnimatePresence>
      )}
    </div>
  )
}

export default TaxesCustomer
